var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgBlueDropdown = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 9 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dropdown"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\xF4\x80\x86\x8A",
    d: "M4.08336 5.45096L4.08335 5.45097L4.08444 5.45217C4.19457 5.57436 4.33428 5.65 4.5 5.65C4.66308 5.65 4.80899 5.57654 4.91736 5.45015L8.49261 1.40195L8.49263 1.40197L8.4944 1.39989C8.59699 1.27939 8.65 1.13198 8.65 0.965235C8.65 0.63782 8.41841 0.35 8.08065 0.35C7.91976 0.35 7.77593 0.421466 7.67277 0.529173L7.67268 0.529085L7.66859 0.533731L4.5 4.12798L1.33141 0.533731L1.33151 0.533646L1.32723 0.529173C1.22476 0.422183 1.08574 0.35 0.919355 0.35C0.581593 0.35 0.35 0.63782 0.35 0.965235C0.35 1.13202 0.403131 1.28088 0.512434 1.40245L4.08336 5.45096Z",
    fill: "#329EF0",
    stroke: "#329EF0",
    strokeWidth: 0.3
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBlueDropdown);
export default ForwardRef;